<script context="module" lang="ts">
    import type { Load } from '@sveltejs/kit';

    export const load: Load = async ({ stuff }) => {
        const query = await stuff.cms.projects();
        return {
            props: { query },
        };
    };
</script>

<script lang="ts">
    import type { ProjectFragment, ProjectsQuery } from '$gen/graphql';
    import ProjectMobileTeaser from '$lib/components/project/ProjectMobileTeaser.svelte';

    export let query: ProjectsQuery;

    $: projects = query?.projects?.filter(isProjectFragment) || [];

    const isProjectFragment = (item): item is ProjectFragment => {
        return (item as ProjectFragment).__typename === 'projects_default_Entry';
    };
</script>

<svelte:head>
    <title>Studio SH | Projects</title>
</svelte:head>

<div class="max-h-screen overflow-y-auto">
    {#each projects as project}
        <ProjectMobileTeaser {project} />
    {/each}
</div>
